import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Verifica se o usuário já aceitou
        const hasAccepted = localStorage.getItem('cookie_consent_accepted');
        if (!hasAccepted) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie_consent_accepted', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div style={styles.overlay}>
            <div style={styles.container}>
                <div style={styles.textContainer}>
                    <p style={styles.title}>🍪 Nós usamos cookies</p>
                    <p style={styles.text}>
                        Este site utiliza cookies essenciais para garantir que você tenha a melhor experiência 
                        na plataforma e manter sua sessão segura. Ao continuar navegando, você concorda com o uso de cookies.
                    </p>
                </div>
                <button onClick={handleAccept} style={styles.button}>
                    Entendi e Aceito
                </button>
            </div>
        </div>
    );
};

const styles = {
    overlay: {
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(15, 23, 42, 0.95)',
        backdropFilter: 'blur(8px)',
        zIndex: 9999,
        padding: '16px 24px',
        boxShadow: '0 -4px 6px -1px rgba(0, 0, 0, 0.1)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)'
    },
    container: {
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px'
    },
    textContainer: {
        flex: '1 1 300px'
    },
    title: {
        margin: '0 0 4px 0',
        color: '#fff',
        fontSize: '16px',
        fontWeight: 'bold'
    },
    text: {
        margin: 0,
        color: '#cbd5e1',
        fontSize: '14px',
        lineHeight: '1.4'
    },
    button: {
        backgroundColor: '#ee4d2d',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        padding: '10px 20px',
        fontSize: '14px',
        fontWeight: 'bold',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        boxShadow: '0 2px 4px rgba(238, 77, 45, 0.3)',
        transition: 'background-color 0.2s'
    }
};

export default CookieConsent;
